/**
 * @generated SignedSource<<1c7e23ba0002865178aca86a2a9e179a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfanityFilterRuleInput = {
  apiKey?: string | null;
  enableImageModeration: boolean;
  enableTextFilter: boolean;
  id?: string | null;
  lang: string;
  langDetection: boolean;
  moderationCategories: ReadonlyArray<ModerationCategoryInput>;
  name: string;
  printTypes: ReadonlyArray<number>;
  products: ReadonlyArray<number>;
};
export type ModerationCategoryInput = {
  moderationCategoryID: number;
  moderationCategoryTypeID: number;
  name?: string | null;
  value?: string | null;
};
export type profanityRuleEditor_UpdateProfanityFilterRuleMutation$variables = {
  input: ProfanityFilterRuleInput;
};
export type profanityRuleEditor_UpdateProfanityFilterRuleMutation$data = {
  readonly updateProfanityFilterRule: {
    readonly profanityFilterRule: {
      readonly id: string;
    } | null;
  } | null;
};
export type profanityRuleEditor_UpdateProfanityFilterRuleMutation = {
  response: profanityRuleEditor_UpdateProfanityFilterRuleMutation$data;
  variables: profanityRuleEditor_UpdateProfanityFilterRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProfanityFilterRuleOutput",
    "kind": "LinkedField",
    "name": "updateProfanityFilterRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfanityFilterRule",
        "kind": "LinkedField",
        "name": "profanityFilterRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "profanityRuleEditor_UpdateProfanityFilterRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "profanityRuleEditor_UpdateProfanityFilterRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "33c821d9fc8b4258ef6e14e7688fb8cb",
    "id": null,
    "metadata": {},
    "name": "profanityRuleEditor_UpdateProfanityFilterRuleMutation",
    "operationKind": "mutation",
    "text": "mutation profanityRuleEditor_UpdateProfanityFilterRuleMutation(\n  $input: ProfanityFilterRuleInput!\n) {\n  updateProfanityFilterRule(input: $input) {\n    profanityFilterRule {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f3d05e03475cf1a332ef4a889ba046d";

export default node;
